import { RefObject, useEffect, useState } from 'react';

const usePanScroll = (scrollerRef: RefObject<HTMLElement>, enabled: boolean): boolean => {
    const [isDragging, setIsDragging] = useState<boolean>(false);

    useEffect(() => {
        const scroller = scrollerRef.current;
        if (!enabled || !scroller) {
            return undefined;
        }
        let start: { x: number; y: number; left: number; top: number } | null = null;
        const onDown = (event: MouseEvent): void => {
            start = {
                x: event.clientX, y: event.clientY, left: scroller.scrollLeft, top: scroller.scrollTop,
            };
            setIsDragging(true);
        };
        const onMove = (event: MouseEvent): void => {
            if (start) {
                scroller.scrollLeft = start.left - (event.clientX - start.x);
                scroller.scrollTop = start.top - (event.clientY - start.y);
            }
        };
        const onUp = (): void => {
            start = null;
            setIsDragging(false);
        };
        scroller.addEventListener('mousedown', onDown);
        window.addEventListener('mousemove', onMove);
        window.addEventListener('mouseup', onUp);
        return () => {
            scroller.removeEventListener('mousedown', onDown);
            window.removeEventListener('mousemove', onMove);
            window.removeEventListener('mouseup', onUp);
            setIsDragging(false);
        };
    }, [enabled, scrollerRef]);

    return isDragging;
};

export default usePanScroll;
